module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [(_vm.loading) ? _c('div', [_c('div', {
    staticClass: "grid grid-cols-12 gap-6 mt-5"
  }, [_c('div', {
    staticClass: "intro-y col-span-12 lg:col-span-12"
  }, [_c('div', {
    staticClass: "intro-y box"
  }, [_vm._m(0), _vm._v(" "), _c('form', {
    staticClass: "p-5 grid grid-cols-12 gap-2",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.putProject.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "col-span-6 sm:col-span-6"
  }, [_c('label', {
    attrs: {
      "for": "msg"
    }
  }, [_vm._v("Nombre")]), _vm._v(" "), _c('input', {
    staticClass: "input w-full border mt-2",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": _vm.project.name
    },
    on: {
      "input": function($event) {
        return _vm.updateValue('name', $event)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-span-6 sm:col-span-6"
  }, [_c('label', [_vm._v("Cuenta")]), _vm._v(" "), _c('select', {
    staticClass: "input w-full border mt-2",
    attrs: {
      "required": ""
    },
    domProps: {
      "value": _vm.project.account_id
    },
    on: {
      "input": function($event) {
        return _vm.updateValue('account_id', $event)
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("Seleccione la cuenta")]), _vm._v(" "), _vm._l((_vm.accounts), function(account) {
    return _c('option', {
      domProps: {
        "value": account.id
      }
    }, [_vm._v("\n                      " + _vm._s(account.name) + "\n                    ")])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col-span-4 sm:col-span-4 mt-3"
  }, [_c('label', [_vm._v("Usuario")]), _vm._v(" "), _c('select', {
    staticClass: "input w-full border mt-2",
    attrs: {
      "required": ""
    },
    domProps: {
      "value": _vm.project.user_id
    },
    on: {
      "input": function($event) {
        return _vm.updateValue('user_id', $event)
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("Seleccione el usuario")]), _vm._v(" "), _vm._l((_vm.users), function(user) {
    return _c('option', {
      domProps: {
        "value": user.id
      }
    }, [_vm._v("\n                      " + _vm._s(user.name) + "\n                    ")])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col-span-4 sm:col-span-4 mt-3"
  }, [_c('label', {
    attrs: {
      "for": "msg"
    }
  }, [_vm._v("Estado")]), _vm._v(" "), _c('select', {
    staticClass: "input w-full border mt-2",
    attrs: {
      "required": ""
    },
    domProps: {
      "value": _vm.project.status
    },
    on: {
      "input": function($event) {
        return _vm.updateValue('status', $event)
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("Seleccione el usuario")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("Inactivo")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Activo")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-span-4 sm:col-span-4 mt-3"
  }, [_c('label', {
    attrs: {
      "for": "msg"
    }
  }, [_vm._v("Horas (Digital)")]), _vm._v(" "), _c('input', {
    staticClass: "input w-full border mt-2",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": _vm.project.hours
    },
    on: {
      "input": function($event) {
        return _vm.updateValue('hours', $event)
      }
    }
  })]), _vm._v(" "), _vm._m(1)])])])])]) : _c('app-loading')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex flex-col sm:flex-row items-center p-5 border-b border-gray-200"
  }, [_c('h2', {
    staticClass: "font-medium text-base mr-auto"
  }, [_vm._v("\n            Editar Proyecto\n          ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-span-12 mt-3"
  }, [_c('button', {
    staticClass: "button w-24 bg-theme-1 text-white",
    attrs: {
      "type": "submit",
      "id": "edit"
    }
  }, [_vm._v("\n                  Modificar\n                ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-18b5cfac","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/project/EditProject.vue
// module id = 412
// module chunks = 1